const FLAG = 'sts_return_explore';
const SCROLL_Y = 'sts_home_scroll_y';

/** Call before navigating from home/category listing to a product page. */
export function rememberHomeScrollBeforeProduct() {
  const path = window.location.pathname || '/';
  const onListing =
    path === '/'
    || path === ''
    || path.startsWith('/category/')
    || path.startsWith('/brand/');
  if (!onListing) return;
  sessionStorage.setItem(SCROLL_Y, String(window.scrollY || 0));
  sessionStorage.setItem(FLAG, '1');
}

export function shouldRestoreHomeScroll() {
  return sessionStorage.getItem(FLAG) === '1';
}

export function clearHomeScrollMemory() {
  sessionStorage.removeItem(FLAG);
  sessionStorage.removeItem(SCROLL_Y);
}

/** Restore scroll after home catalog is ready (or immediately if already painted). */
export function restoreHomeScroll() {
  if (!shouldRestoreHomeScroll()) return false;
  const y = Number(sessionStorage.getItem(SCROLL_Y) || 0);
  clearHomeScrollMemory();

  const apply = () => {
    if (y > 80) {
      window.scrollTo(0, y);
      return;
    }
    const el = document.getElementById('explore-products');
    if (el) {
      el.scrollIntoView({ behavior: 'auto', block: 'start' });
    } else {
      window.scrollTo(0, 0);
    }
  };

  // Wait a frame so ExploreProducts can paint cached products
  requestAnimationFrame(() => {
    requestAnimationFrame(apply);
  });
  return true;
}
